import React from 'react';

const OrganisationResultsContext = React.createContext();

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'setLoadingPublishedBy':
      return { ...state, loadingPublishedBy: payload };
    case 'setPublishedByWires':
      return { ...state, publishedByWires: payload };
    case 'setMentionedWires':
      return { ...state, mentionedWires: payload };
    case 'setContributors':
      return { ...state, contributors: payload };
    case 'setStockCodes':
      return { ...state, stockCodes: payload };
    case 'setKeywords':
      return { ...state, keywords: payload };
    case 'setAreasOfExpertise':
      return { ...state, areasOfExpertise: payload };
    default:
      throw new Error();
  }
};

const defaultState = {
  loadingPublishedBy: null,
  publishedByWires: [],
  mentionedWires: [],
  contributors: [],
  stockCodes: [],
  keywords: [],
  areasOfExpertise: [],
};

export default OrganisationResultsContext;
export {
  reducer,
  defaultState,
};
